import React from 'react';
import {
  Alert,
  AlertIcon,
  Box,
  Flex,
  HStack,
  Text,
  VStack,
  IconButton,
  useDisclosure,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerBody,
} from '@chakra-ui/react';
import { FiMenu } from 'react-icons/fi';
import SaktiSidebar from '../components/SaktiSidebar';
import SaktiSpbFilterBar from '../components/SaktiSpbFilterBar';
import SaktiSpbKpiCards from '../components/SaktiSpbKpiCards';
import SaktiSpbTable from '../components/SaktiSpbTable';
import SaktiSpbDetailModal from '../components/SaktiSpbDetailModal';
import { useSaktiSpbDashboard } from '../hooks/useSaktiSpbDashboard';
import { SAKTI_UI_SIZE } from '../uiSizes';
import { SaktiSpbListItem } from '../types';

const SaktiSpbPage: React.FC = () => {
  const {
    options,
    loadingOptions,
    loadingKpi,
    loadingTable,
    draftFilters,
    kpi,
    rows,
    pagination,
    tableError,
    onDraftFilterChange,
    applyFilters,
    goToPage,
  } = useSaktiSpbDashboard();

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedItem, setSelectedItem] = React.useState<SaktiSpbListItem | null>(null);

  const { 
    isOpen: isMobileSidebarOpen, 
    onOpen: onMobileSidebarOpen, 
    onClose: onMobileSidebarClose 
  } = useDisclosure();

  return (
    <Box minH="100vh" bg="#ECEEF1">
      <Flex align="stretch">
        <Box display={{ base: 'none', xl: 'block' }}>
          <SaktiSidebar activeMenu="spb" />
        </Box>

        <Drawer isOpen={isMobileSidebarOpen} placement="left" onClose={onMobileSidebarClose} size="xs">
          <DrawerOverlay />
          <DrawerContent>
            <DrawerCloseButton zIndex={10} color="gray.500" />
            <DrawerBody p={0}><SaktiSidebar activeMenu="spb" /></DrawerBody>
          </DrawerContent>
        </Drawer>

        <Box flex={1} p={SAKTI_UI_SIZE.pagePadding}>
          <VStack align="stretch" spacing={SAKTI_UI_SIZE.sectionGap}>
            <HStack justify="space-between" align={{ base: 'start', md: 'center' }} flexWrap="wrap">
              <HStack spacing={3} align="center">
                <IconButton aria-label="Menu" icon={<FiMenu />} variant="outline" bg="white" display={{ base: 'flex', xl: 'none' }} onClick={onMobileSidebarOpen} />
                <VStack align="start" spacing={0}>
                  <Text fontSize={SAKTI_UI_SIZE.pageTitle} fontWeight="bold" color="gray.900">SPB (Surat Pengiriman Barang)</Text>
                  <Text color="gray.600" fontSize="sm">Pengiriman TBS dari estate ke pabrik</Text>
                </VStack>
              </HStack>
            </HStack>

            <SaktiSpbFilterBar filters={draftFilters} options={options} onFiltersChange={onDraftFilterChange} onApply={applyFilters} isApplying={loadingOptions || loadingTable} />
            <SaktiSpbKpiCards loading={loadingKpi || loadingOptions} data={kpi} />

            {tableError && <Alert status="warning" borderRadius="lg"><AlertIcon />{tableError}</Alert>}

            <SaktiSpbTable
              loading={loadingTable || loadingOptions}
              rows={rows}
              pagination={pagination}
              onPageChange={goToPage}
              onViewDetail={(id) => {
                const item = rows.find(r => r.id === id);
                if (item) {
                  setSelectedItem(item);
                  onOpen();
                }
              }}
              onEdit={(id) => console.log('Edit', id)}
            />
          </VStack>
        </Box>
      </Flex>

      <SaktiSpbDetailModal
        isOpen={isOpen}
        onClose={onClose}
        data={selectedItem}
      />
    </Box>
  );
};

export default SaktiSpbPage;
